import { useTranslation } from 'next-i18next'
import { FC } from 'react'

import Input from '~/bootcamp/Activities/components/Input'

const LatticeDigit: FC<{
  digit: string
  hasCarriedNumber: boolean
  onCarriedChange: (value: string, name: string) => void
  onEnter?: () => void
  name: string
  hasCarriedMultiplicand: boolean
  carriedValue: string
}> = ({ digit, hasCarriedNumber, onCarriedChange, name, carriedValue, hasCarriedMultiplicand, onEnter }) => {
  return (
    <div className={`flex items-center ${hasCarriedMultiplicand && name ? 'justify-end' : 'justify-center'}`}>
      {hasCarriedNumber && (
        <Input
          className="mr-2"
          isSmall
          maxDigits={1}
          name={name}
          onChange={onCarriedChange}
          onEnter={onEnter}
          value={carriedValue}
        />
      )}
      <p className="lg:text-2xl sm:text-5 font-semibold text-purple">{digit}</p>
    </div>
  )
}

const LatticeDigitWithDecimal: FC<{
  digit: string
  decimalPosition: 'right' | 'bottom'
  decimalIndexes: number[]
  itemIndex: number
  carriedName: string
  hasCarriedNumber: boolean
  carriedValue: string
  onCarriedChange: (name: string, value: string) => void
  onEnter?: () => void
}> = ({
  digit,
  decimalPosition,
  decimalIndexes,
  itemIndex,
  hasCarriedNumber,
  carriedValue,
  carriedName,
  onCarriedChange,
  onEnter,
}) => {
  const [multiplierCommaIndex, multiplicandCommaIndex] = decimalIndexes
  const { t } = useTranslation('bootcamp')
  const decimalStyle = decimalPosition === 'bottom' ? '-bottom-2 translate-y-1/2' : 'right-0 -right-2 translate-x-1/2'

  const showDecimal =
    (decimalPosition === 'bottom' && itemIndex === multiplicandCommaIndex) ||
    (decimalPosition === 'right' && itemIndex === multiplierCommaIndex)

  return (
    <div
      className={`lg:text-2xl sm:text-5 font-semibold text-purple relative flex  items-center ${
        decimalPosition === 'bottom' ? 'justify-end h-10 lg:h-20' : 'justify-center w-10 lg:w-20'
      }`}
    >
      {hasCarriedNumber && (
        <Input
          className="mr-2"
          isSmall
          maxDigits={1}
          name={carriedName}
          onChange={onCarriedChange}
          onEnter={onEnter}
          value={carriedValue}
        />
      )}
      <p>{digit}</p>
      {showDecimal && <p className={`absolute ${decimalStyle}`}>{t('signs.decimal')}</p>}
    </div>
  )
}

export { LatticeDigit, LatticeDigitWithDecimal }
